/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon, FlexRow, FlexCol, Button, Label } from 'sarsaparilla';
import { jsUcfirst } from '../../utils/utilsNew';
import SmartSelector from './SmartSelector';

const propTypes = {
    name: PropTypes.string,
    removeItem: PropTypes.func,
    handleTypeChange: PropTypes.func,
    handleAmountChange: PropTypes.func,
    item: PropTypes.shape({
        type: PropTypes.string,
        amount: PropTypes.number,
    }),
    index: PropTypes.number,
    innerRef: PropTypes.shape({ current: PropTypes.node }),
    itemType: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
        })
    ),
};
export default class GenericItem extends React.Component {
    constructor(props) {
        super(props);

        this.changeItemType = this.changeItemType.bind(this);
        this.changeItemQuantity = this.changeItemQuantity.bind(this);
    }

    componentDidMount() {
        // When an item is created and has a refrence, focus to it
        if (this.props.innerRef && this.props.innerRef.current) {
            setTimeout(() => {
                this.props.innerRef.current.focus();
            }, 2000);
        }
    }

    changeItemType(e) {
        this.props.handleTypeChange(e.target.value);
    }

    changeItemQuantity(e) {
        this.props.handleAmountChange(e.target.value);
    }

    renderRemoveButton() {
        const { index, itemType, removeItem } = this.props;

        return (
            <FlexCol xs={2} alignSelf="end">
                <div className="per-form-group-item-remove">
                    <Button
                        appearance="subtle-danger"
                        type="button"
                        iconBeforeElement={<Icon iconName="delete" />}
                        onClick={removeItem}
                        screenReaderTextBefore={`Remove row ${index} from the ${itemType} list`}
                    >
                        Delete
                    </Button>
                </div>
            </FlexCol>
        );
    }

    render() {
        const { itemType, index, item, options } = this.props;
        const selectorProps = {
            name: `${itemType}-type`,
            id: `${itemType}-type-${index}`,
            value: item.type.toString(),
            handleChange: this.changeItemType,
            options,
            label: `${jsUcfirst(itemType)} Type`,
            isLabelVisible: true,
            isRequired: true,
        };

        return (
            <div className="per-form-group-item">
                <FlexRow>
                    <FlexCol xs={4}>
                        <div className="rec-form-item-wrap animal-selector">
                            <SmartSelector {...selectorProps} />
                        </div>
                    </FlexCol>
                    <FlexCol xs={2}>
                        <div className="rec-form-item-wrap">
                            <Label
                                htmlFor={`${this.props.itemType}-amount-${index}`}
                                isRequired
                            >
                                Quantity
                            </Label>
                            <input
                                type="number"
                                className={`${this.props.itemType}-amount`}
                                id={`${this.props.itemType}-amount-${index}`}
                                min="0"
                                value={item.amount.toString()}
                                required
                                onChange={this.changeItemQuantity}
                            />
                        </div>
                    </FlexCol>
                    {this.renderRemoveButton()}
                </FlexRow>
            </div>
        );
    }
}

GenericItem.propTypes = propTypes;
